import { useState } from 'react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Permission from 'shared/features/auth/authorization/enums/permission';
import usePermissionAuthorization from 'shared/features/auth/authorization/hooks/permission-authorization';

import './tabs.scss';

export type Tab = {
  title: string;
  permission?: Permission;
  value: number;
};

type Props = {
  tabs: Tab[];
  onTabChanged: (tabValue: number) => void;
};

const Tabs = ({ tabs, onTabChanged }: Readonly<Props>): React.JSX.Element => {
  const { hasPermission } = usePermissionAuthorization();
  const [currentValue, setCurrentValue] = useState(0);

  const handleChange = (_: React.MouseEvent<HTMLElement>, newValue: number): void => {
    setCurrentValue(newValue);
    onTabChanged(newValue);
  };

  const permissibleTabs = tabs.filter((tab) => !tab.permission || hasPermission(tab.permission));

  return (
    <>
      {permissibleTabs.length > 1 && (
        <div className="page-tab-container">
          <ToggleButtonGroup color="primary" value={currentValue} exclusive onChange={handleChange} aria-label="Platform">
            {permissibleTabs.map((tab) => {
              return (
                <ToggleButton data-testid={'tab-' + tab.title} key={tab.value} value={tab.value} disabled={tab.value === currentValue}>
                  <div className="button-container">
                    {tab.value === currentValue && <CheckRoundedIcon className="icon" fontSize="small" />}
                    {tab.title}
                  </div>
                </ToggleButton>
              );
            })}
          </ToggleButtonGroup>
        </div>
      )}
    </>
  );
};

export default Tabs;
